import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, numberFormat,axisTextDim4, colourScheme, createAxis} from '../functions'

export default function (chart, divId, vizName, filterParam, checkbox) {

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    axios.post(url, filterParam).then(response => {
        let data = response.data;

        // Nest the entries by symbol
        var states = d3.nest().key(function (d) {
            return d.dim1_name;
        }).sortKeys(d3.ascending).entries(data)

        console.log(states)

        // Nest the entries by symbol
        var dNest = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            }).sortKeys(d3.ascending)
            .key(function (d) {
                return d.dim3_name;
            })
            .entries(data);

        var legendtext = dNest[0].values.map(function (d) {
            return d.key
        })

        console.log("legendtext", legendtext)

        console.log("value of dNest", dNest)
        console.log("color", colourScheme(chart.colourscheme1))

        dNest.forEach(function (group) {
            group.values.forEach(function (innerGroup) {
                innerGroup.values.forEach(function (d) {
                    console.log("value of before d.dim", d.dim2_name);

                    // Check if the format is YYYY-MM (assuming it's a date)
                    if (/^\d{4}-\d{2}$/.test(d.dim2_name)) {
                        d.dim2_name = new Date(d.dim2_name);
                        console.log("value of d.dim", d.dim2_name);
                    }

                    d.metric1 = +d.metric1;
                });
            });
        });
        // var value1=d3.extent(data, function (d) {
        //     return d[chart.x1DataFieldName];
        // })
        // var value1=data.map((d) => {
        //     return d[chart.x1DataFieldName]
        // });

        let value1;
        let rang;

        switch (chart.x1D3ScaleType) {
            case "linearScale":
                value1 = [d3.min(data, d => d.dim2_name), d3.max(data, d => d.dim2_name)];
                rang = [0, chart.width];
                break;

            case "bandScale":
                value1 = data.map(d => d[chart.x1DataFieldName]);
                rang = [0, chart.width];
                break;

            case "timeScale":
                value1 = d3.extent(data, d => d[chart.x1DataFieldName]);
                rang = [0, chart.width];
                break;

            default:
                // Handle any other cases or provide a default behavior
                console.error("Invalid x1D3ScaleType:", chart.x1D3ScaleType);
        }

        console.log("value of chart.x1D3ScaleType", chart.x1D3ScaleType);

        if (value1 && rang) {

            // var value1=[d3.min(data, d => {return d.dim2_name}),d3.max(data, d => {return d.dim2_name})];
            // var rang=[0,chart.width];
            console.log("value of chart.x1D3ScaleType", chart.x1D3ScaleType);
            var x1AxisScaleType = "timeScale";
            console.log("value of x1Axis", x1AxisScaleType);

            var x = createAxis(chart.x1D3ScaleType).domain(value1).range(rang);
            //console.log("value of x in console",x)

            var y = d3.scaleLinear().range([chart.height, 0]);
            // console.log('Inside mmlChart',colourscheme("d3.interpolateYlOrRd"));

            var xAxis;
            var formatTime = d3.timeFormat("%Y-%m");
            //Format d.date variable

            if (x1AxisScaleType == chart.x1D3ScaleType) {
                // Define the axes
                xAxis = d3.axisBottom(x).tickFormat(formatTime);
            } else {
                xAxis = d3.axisBottom(x);
            }
            var yAxis = d3.axisLeft(y).tickFormat(numberFormat);

            // x.domain(d3.extent(data, function (d) {
            //     return d.dim2_name;
            // }));

            if (checkbox == false) {
                var div = d3.select(divId)
                div.selectAll("*").remove();

                // Adds the canvas
                div = d3.select(divId).selectAll("svg")
                    .data(dNest)
                    .enter()
                    .append("svg")
                    .attr("width", chart.width)
                    .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                    .attr("font", "Arial")
                    .style("font-size", "14px")
                    .append("g")
                    .attr("transform",
                        "translate(" + chart.margin.left + "," + chart.margin.top + ")")
                    .attr("id", function (d) {
                        console.log("div ", d.key);
                        return d.key;
                    })

                states.forEach(function (d) {
                    //CSS.escape(id) - will escape special character in id/key
                    var div = d3.select("#" + CSS.escape(d.key));

                    y.domain([0, d3.max(d.values, function (d) {
                        return d.metric2
                    })])


                    // Add the div for the tooltip
                    var div1 = d3.select("body").append("div1").attr("class", "tooltip").style("opacity", 0);

                    var metric1ColorScale = d3.scaleOrdinal(d3.schemeCategory10)

                    // var color = function(d) {
                    //     return d =='accidents' ? "blue" : d == 'Fatal' ? "red" : d =='Injuries' ? "orange" : metric1ColorScale(d);
                    // }
                    // // set the colour scale
                    // var metric2ColorScale =  d3.scaleOrdinal().range(color)

                    // Add the X Axis
                    div.append("g")
                        .attr("class", "x axis")
                        .attr("transform", "translate(0," + chart.height + ")")
                        .call(xAxis);
                    // .selectAll('.x.axis .tick line')  // Select tick lines for x-axis
                    // .attr('transform', `translate(-55, 0)`)
                    // .style('stroke', 'black')  // Add border color
                    // .style('stroke-width', 0.4) // Set border width
                    // .selectAll('.x.axis .text')
                    // .attr('transform', `translate(-55, 0)`)
                    // .attr('dy', '.5em') // Adjust vertical spacing
                    //.attr('transform', 'translate(0, 0) rotate(0)')

                    //adding axis labels
                    div.append("text")
                        .attr("transform", "translate(" + (chart.width / 2) + " ," + (chart.height + chart.margin.top + 35) + ")")
                        .style("text-anchor", "middle")
                        .attr("font-size", "15px")
                        .style('fill', 'blue')
                        .text(chart.x1AxisDisplayName);

                    // Add the Y Axis
                    div.append("g").attr("class", "y axis").call(yAxis);

                    div.append("text")
                        .attr("transform", "rotate(-90)")
                        .attr("x", -40)
                        .attr("y", 65)
                        .attr("dy", "-8em")
                        .style("text-anchor", "end")
                        .attr("font-size", "15px")
                        .style('fill', 'blue')
                        // .style('display', 'none')
                        .text(chart.y1AxisDisplayName);


                    div.append("g")
                        .append("text")
                        .attr("x", -40)
                        .attr("y", chart.height / 1.5)
                        .attr("dy", "-9em")
                        .attr("text-anchor", "start")
                        .attr("font-size", "1.1em")
                        //  .style("fill",function(d) { return color(d.key) })
                        .text(function (d) {
                            return d.key
                        });

                    /* div.append("g")
                      .append("text")
                      .attr('transform', 'rotate(90)')
                      .attr("x", chart.width + 25)
                      .attr("y", chart.height/2.5)
                      .attr("dy", ".71em")
                      .attr("text-anchor", "start")
                      .attr("font-size", "1.1em")
                      .text(function(d) { return d.key})*/

                    // Loop through each symbol / key for metric1
                    var linesMetric1 = div.selectAll(".line-metric1")
                        .data(function (d) {
                            return d.values;
                        })
                        .enter()
                        .append("path")
                        .attr("class", function (d) {
                            // Add a class based on the line type for metric1
                            return "line-metric1 " + d.key.replace(/\s+/g, '');
                        })
                        .style("stroke", function (d) {
                            return d.key == 'All' ? "#1399a6" : d.key == 'Apple' ? "orange" : d.key == 'Lenovo' ? "#13e73d" : metric1ColorScale(d.key);
                        })
                        .attr("stroke-width", 2)
                        .attr("fill", "none")
                        .attr('d', (d) => {
                            let line = d3.line()
                                .x(d => {
                                    return x(d[chart.x1DataFieldName]);
                                })
                                .y(d => {
                                    return y(+d.metric1);
                                });

                            return line(d.values);
                        })
                        .style("stroke-dasharray", function (d) {
                            // Apply different dash styles based on the line type for metric1
                            return d.key == 'All' ? "2,2" : d.key == 'Lenovo' ? "2,2" : d.key == 'Apple' ? "2,2" : "none";
                        })
                        .style("stroke-dashoffset", 0); // Make sure dash offset is 0

                    // Add dots for metric1
                    div.selectAll("dot")
                        .data(function () {
                            return d.values
                        })
                        .enter().append("circle")
                        .attr("r", 5)
                        .attr("cx", function (d) {
                            return x(d[chart.x1DataFieldName]);
                        })
                        .attr("cy", function (d) {
                            return y(d.metric1);
                        })
                        .style("fill", function (d) {
                            return d.dim3_name == 'All' ? "#1399a6" : d.dim3_name == 'Apple' ? "orange" : d.dim3_name == 'Lenovo' ? "#13e73d" : metric1ColorScale(d.dim3_name);
                        })
                        //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                        .on("mouseover", function (d) {
                            div1.transition()
                                .duration(200)
                                .style("opacity", .9);
                            div1.html(chart.x1MetricTooltip + colonAnnotation + formatTime(d.dim2_name) + "<br/>" +
                                chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                chart.y2MetricTooltip + colonAnnotation + numberFormat(d.metric1))
                                .style("left", (d3.event.pageX) + "px")
                                .style("top", (d3.event.pageY - 28) + "px");
                        })
                        .on("mouseout", function () {
                            div1.transition().duration(500).style("opacity", 0);
                        });

// Add a new set of lines for metric2
                    var linesMetric2 = div.selectAll(".line-metric2")
                        .data(function (d) {
                            return d.values;
                        })
                        .enter()
                        .append("path")
                        .attr("class", function (d) {
                            // Add a class based on the line type for metric1
                            return "line-metric1 " + d.key.replace(/\s+/g, '');
                        })
                        .style("stroke", function (d) {
                            return d.key == 'All' ? "#1399a6" : d.key == 'Apple' ? "orange" : d.key == 'Lenovo' ? "#13e73d" : metric1ColorScale(d.key);
                        })
                        .attr("stroke-width", 2)
                        .attr("fill", "none")
                        .attr('d', (d) => {
                            let line = d3.line()
                                .x(d => {
                                    return x(d[chart.x1DataFieldName]);
                                })
                                .y(d => {
                                    return y(+d.metric2);
                                });

                            return line(d.values);
                        })
                        .style("stroke-dasharray", function (d) {
                            // Apply different dash styles based on the line type for metric1
                            return d.key == '' ? "2,2" : d.key == '' ? "2,2" : d.key == '' ? "2,2" : "none";
                        })
                        .style("stroke-dashoffset", 0);
// Log the generated lines for metric1 and metric2
                    console.log("Lines for metric1:", linesMetric1);
                    console.log("Lines for metric2:", linesMetric2);

                    div.selectAll("dot")
                        .data(function () {
                            return d.values
                        })
                        .enter().append("circle")
                        .attr("r", 5)
                        .attr("cx", function (d) {
                            return x(d[chart.x1DataFieldName]);
                        })
                        .attr("cy", function (d) {
                            return y(d.metric2);
                        })
                        .style("fill", function (d) {
                            return d.dim3_name == 'All' ? "#1399a6" : d.dim3_name == 'Lenovo' ? "#13e73d" : d.dim3_name == 'Apple' ? "orange" : metric1ColorScale(d.dim3_name);
                        })
                        //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                        .on("mouseover", function (d) {
                            div1.transition()
                                .duration(200)
                                .style("opacity", .9);
                            div1.html(chart.x1MetricTooltip + colonAnnotation + formatTime(d.dim2_name) + "<br/>" +
                                chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                chart.y2MetricTooltip + colonAnnotation + numberFormat(d.metric1))
                                .style("left", (d3.event.pageX) + "px")
                                .style("top", (d3.event.pageY - 28) + "px");
                        })
                        .on("mouseout", function () {
                            div1.transition().duration(500).style("opacity", 0);
                        });

                    var y1legend = div.selectAll(".legend")
                        .append("svg")
                        .attr('class', 'legend')
                        .data(function (d) {
                            return d.values
                        })
                        .enter()
                        .append("g")
                        .attr('transform', function (d, i) {                     // NEW
                            //  var height = 0;          // NEW
                            var horz = 80 * i;                       // NEW
                            var vert = 240;                        // NEW
                            return 'translate(' + horz + ',' + vert + ')';        // NEW
                        });


                    y1legend.append('circle')
                        .attr('x', 5)
                        .attr('y', chart.height + 2 * chart.margin.bottom)
                        .attr("r", 5)
                        .style('fill', function (d) {
                            return d.key == 'All' ? "#1399a6" : d.key == 'Apple' ? "orange" : d.key == 'Lenovo' ? "#13e73d" : metric1ColorScale(d.key);
                        });


                    y1legend.append('text')
                        .attr('x', 15)
                        .attr('y', chart.height + 2 * chart.margin.bottom + 3)
                        .attr('dy', '-30em')
                        .style('font-size', '12px')
                        .text(function (d) {
                            return d.key.substring(0, 10) + "..."
                        })
                })
            }
            else {
                div = d3.select(divId)
                div.selectAll("*").remove();

                // Adds the canvas
                div = d3.select(divId).selectAll("svg")
                    .data(dNest)
                    .enter()
                    .append("svg")
                    .attr("width", chart.width + chart.margin.left + chart.margin.right)
                    .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
                    .attr("font", "Arial")
                    .style("font-size", "14px")
                    .append("g")
                    .attr("transform",
                        "translate(" + chart.margin.left + "," + chart.margin.top + ")")
                    .attr("id", function (d) {
                        console.log("div ", d.key);
                        return d.key;
                    })

                states.forEach(function (d) {
                    //CSS.escape(id) - will escape special character in id/key
                    var div = d3.select("#" + CSS.escape(d.key));

                    //  y.domain([0,d3.max(d.values, function(d) { return d.metric1 })])
                    y.domain([0, d3.max(data.map((d) => {
                        return d.metric1
                    }))]);


                    // Add the div for the tooltip
                    var div1 = d3.select("body").append("div1").attr("class", "tooltip").style("opacity", 0);

                    var metric1ColorScale = d3.scaleOrdinal(d3.schemeCategory10)

                    // var color = function(d) {
                    //     return d =='accidents' ? "blue" : d == 'Fatal' ? "red" : d =='Injuries' ? "orange" : metric1ColorScale(d);
                    // }
                    // // set the colour scale
                    // var metric2ColorScale =  d3.scaleOrdinal().range(color)

                    // Add the X Axis
                    div.append("g")
                        .attr("class", "x axis")
                        .attr("transform", "translate(0," + chart.height + ")")
                        .call(xAxis);

                    //adding axis labels
                    div.append("text")
                        .attr("transform", "translate(" + (chart.width / 2) + " ," + (chart.height + chart.margin.top + 35) + ")")
                        .style("text-anchor", "middle")
                        .attr("font-size", "15px")
                        .style('fill', 'blue')
                        .text(chart.x1AxisDisplayName);

                    // Add the Y Axis
                    div.append("g").attr("class", "y axis").call(yAxis);

                    div.append("text")
                        .attr("transform", "rotate(-90)")
                        .attr("x", -40)
                        .attr("y", 65)
                        .attr("dy", "-8em")
                        .style("text-anchor", "end")
                        .attr("font-size", "15px")
                        .style('fill', 'blue')
                        // .style('display', 'none')
                        .text(chart.y1AxisDisplayName);


                    div.append("g")
                        .append("text")
                        .attr("x", -40)
                        .attr("y", chart.height / 1.5)
                        .attr("dy", "-9em")
                        .attr("text-anchor", "start")
                        .attr("font-size", "1.1em")
                        //  .style("fill",function(d) { return color(d.key) })
                        .text(function (d) {
                            return d.key
                        });

                    /* div.append("g")
                          .append("text")
                          .attr('transform', 'rotate(90)')
                          .attr("x", chart.width + 25)
                          .attr("y", chart.height/2.5)
                          .attr("dy", ".71em")
                          .attr("text-anchor", "start")
                          .attr("font-size", "1.1em")
                          .text(function(d) { return d.key})*/

                    // Loop through each symbol / key
                    var lines = div.selectAll(".line")
                        .data(function (d) {
                            return d.values
                        })
                        .enter()
                        .append("path")
                        .attr("class", "line")
                        .style("stroke", function (d) { // Add the colours dynamically
                            return d.key == 'accidents' ? "blue" : d.key == 'Fatal' ? "red" : d.key == 'Injuries' ? "orange" : metric1ColorScale(d.key);
                        })
                        // .attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                        .attr("stroke-width", 2)
                        .attr("fill", "none")
                        .attr('d', (d) => {
                            let line = d3.line()
                                .x(d => {
                                    return x(d[chart.x1DataFieldName])
                                })
                                .y(d => {
                                    return y(+d.metric1)
                                })

                            return line(d.values)
                        })

                    console.log(lines)
                    // Add the dots for the tooltip
                    div.selectAll("dot")
                        .data(function () {
                            return d.values
                        })
                        .enter().append("circle")
                        .attr("r", 5)
                        .attr("cx", function (d) {
                            return x(d[chart.x1DataFieldName]);
                        })
                        .attr("cy", function (d) {
                            return y(d.metric1);
                        })
                        .style("fill", function (d) {
                            return d.dim3_name == 'accidents' ? "blue" : d.dim3_name == 'Fatal' ? "red" : d.dim3_name == 'Injuries' ? "orange" : metric1ColorScale(d.dim3_name);
                        })
                        //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                        .on("mouseover", function (d) {
                            div1.transition()
                                .duration(200)
                                .style("opacity", .9);
                            div1.html(chart.x1MetricTooltip + colonAnnotation + formatTime(d.dim2_name) + "<br/>" +
                                chart.x2MetricTooltip + colonAnnotation + d.dim1_name + "<br/>" +
                                chart.y1MetricTooltip + colonAnnotation + d.dim3_name + "<br/>" +
                                chart.y2MetricTooltip + colonAnnotation + numberFormat(d.metric1))
                                .style("left", (d3.event.pageX) + "px")
                                .style("top", (d3.event.pageY - 28) + "px");
                        })
                        .on("mouseout", function () {
                            div1.transition().duration(500).style("opacity", 0);
                        });

                    var y1legend = div.selectAll(".legend")
                        .append("svg")
                        .attr('class', 'legend')
                        .data(function (d) {
                            return d.values
                        })
                        .enter()
                        .append("g")
                        .attr('transform', function (d, i) {                     // NEW
                            //  var height = 0;          // NEW
                            var horz = 100 * i;                       // NEW
                            var vert = 240;                        // NEW
                            return 'translate(' + horz + ',' + vert + ')';        // NEW
                        });


                    y1legend.append('circle')
                        .attr('x', 5)
                        .attr('y', chart.height + 2 * chart.margin.bottom)
                        .attr("r", 5)
                        .style('fill', function (d) {
                            return d.key == 'accidents' ? "blue" : d.key == 'Fatal' ? "red" : d.key == 'Injuries' ? "orange" : metric1ColorScale(d.key);
                        });


                    y1legend.append('text')
                        .attr('x', 15)
                        .attr('y', chart.height + 2 * chart.margin.bottom + 3)
                        .attr('dy', '-30em')
                        .style('font-size', '12px')
                        .text(function (d) {
                            // return d.key.substring(0, 10) + "..."
                            return axisTextDim4(d.key)

                        })

                })
            }
        }
    })
}
